<div class="row">
  <div class="col-xs-12" *ngIf="plan.termsConditions">
    <div class="background3" style="padding: 10px">
      <!--<div class="big text-bold">{{'PARTECIPANT_LTI.DOCUMENTS.TERMS_CONDITIONS' | translate}}</div>-->
      <div
        class="pointer"
        style="margin-top: 30px"
        (click)="openPdf('./assets/pdf/MyLTIForm.pdf')"
      >
        <i class="fa fa-file-pdf-o fa-3x"></i>
        <br />
        <small>./assets/pdf/MyLTIForm.pdf</small>
      </div>
    </div>
  </div>

  <div class="col-xs-12" *ngIf="!plan.termsConditions">
    <div class="background3" style="padding: 10px; width: 90vw; height: 90vh">
      <!--<div class="big text-bold">{{'PARTECIPANT_LTI.DOCUMENTS.TERMS_CONDITIONS' | translate}}</div>-->
      <div class="pointer">
        <pdf-viewer
          (click)="openPdf('./assets/pdf/MyLTIForm.pdf')"
          [src]="'./assets/pdf/MyLTIForm.pdf'"
          [show-all]="false"
          [autoresize]="true"
          [original-size]="false"
          style="margin: 10px auto; display: block"
        ></pdf-viewer>
      </div>
      <div class="" style="padding: 10px">
        <div class="col-xs-12 menuMobileItemGroup">
          <div class="bigYellowButton" (click)="plan.termsConditions = true">
            {{ 'PARTECIPANT_LTI.DOCUMENTS.ACCEPT' | translate | uppercase }}
          </div>
        </div>
        <!--
          <div class="form-check">
            <input class="form-check-input magic-checkbox" [(ngModel)]="plan.termsConditions" type="checkbox" id="termsConditions">
            <label class="form-check-label" for="termsConditions">
              {{'PARTECIPANT_LTI.DOCUMENTS.ACCEPT' | translate}}
            </label>
          </div>
          -->
      </div>
    </div>
  </div>
</div>
